var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isLogin)?_c('div',[_c('core-toolbar',{attrs:{"logout":_vm.logout,"toggle":_vm.toggle,"fullscreen":_vm.fullscreen}}),_c('core-drawer'),_c('core-view')],1):_c('div',[_c('Login')],1),(_vm.loading)?_c('Loader',{attrs:{"loading":_vm.loading}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }